import { Link } from 'react-router-dom';
import { articles } from '@/mocks/home';

export default function ArticlePreview() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              最新攻略与资讯
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              掌握游戏技巧，了解平台最新动态
            </p>
          </div>
          <Link
            to="/articles"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer mt-4 sm:mt-0"
          >
            查看全部文章 →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-accent-100 text-accent-700">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="text-xs text-foreground-500">· {article.readTime}</span>
                </div>
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}